<template lang="html">
  <!-- <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" /> -->
  <div class="bg-white p-5 rounded">
    <h1 class="title text-primary" style="font-weight: 700">Jouw code is</h1>
    <h1 class="title text-primary" style="font-weight: 300">
      {{ getSavedCode }}
    </h1>
  </div>
</template>

<script>
export default {
  name: "CodeScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
  }),
  computed: {
    getSavedCode() {
      return this.$store.getters.getCode;
    },
  },
  methods: {},
};
</script>

<style lang="css" scoped>
.title {
  padding-bottom: 10px;
  font-size: 30px;
  color: #161743 !important;
}
</style>
